export default "/images/d8acf59b02c313fbe351f62e0fde0714.avif";